//import HighlightIcon from "@mui/icons-material/Highlight";
//import { yellow } from "@mui/material/colors";
import { ReactComponent as MarkNotesIcon } from "../../logo.svg";
//const color = yellow[500];
//<HighlightIcon sx={{ color: { color }, ml: "2px", mr: "5px" }} />
function DashHeader() {
  return (
    <header className="nav-header">
      <h1>
        <MarkNotesIcon />
        MarkNotes
      </h1>
    </header>
  );
}

export default DashHeader;
